import Section from 'Components/ContractGenerator/layouts/Section';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import Form from './Form';

const ContractData = ({ darkened }) => {
	const { t } = useTranslation(['contractGenerator', 'translation']);

	const dataToSubmit = useSelector(contractGeneratorSelectors.getDataToSubmit);
	const fieldInfo = useSelector(contractGeneratorSelectors.getFieldInfo);
	const formFields = useSelector(contractGeneratorSelectors.getFormFields);
	const forms = useSelector(contractGeneratorSelectors.getForms);

	const formsToRender = useMemo(() => {
		const returnArray = [];

		forms.forEach(form => {
			let compareValue = get(dataToSubmit, form.conditions.field, '');
			if (typeof compareValue === 'object') {
				compareValue = compareValue.key;
			}

			if (!form.conditions.isConditional || (form.conditions.isConditional && compareValue === form.conditions.needsToBeValue)) {
				returnArray.push(form.name);
			}
		});

		return returnArray;
	}, [forms, dataToSubmit]);

	return (
		<Section
			darkened={darkened}
			headline={t('pages.step2.contractData.headline')}
			id='viato-contract-generator-forms'
			lastElementOfStep
		>
			{formsToRender.map((form, index) => (
				<Fragment key={form}>
					<Form
						fieldInfo={get(fieldInfo, `formData.${form}`, {})}
						formData={get(dataToSubmit, `formData.${form}`, {})}
						formFields={get(formFields, form, [])}
						formName={form}
						headline={t(`translation:forms.${form}.formName`)}
					/>
					{index + 1 < formsToRender.length && <Spacer height='xxl' />}
				</Fragment>
			))}
			<Spacer height='xxl' />
			<Spacer height='xxl' />
		</Section>
	);
};

ContractData.propTypes = {
	darkened: PropTypes.bool.isRequired
};

export default ContractData;
